const n = /* @__PURE__ */ new Map(), d = (s, t) => {
  s.querySelectorAll('style[cssr-id^="vueuc"]').forEach((r) => {
    const e = r.getAttribute("cssr-id");
    e && !t.querySelector(`style[cssr-id="${e}"]`) && t.appendChild(r.cloneNode(!0));
  });
}, i = (s) => {
  if (n.has(s))
    return n.get(s);
  const t = new MutationObserver((r) => {
    for (const e of r)
      e.type === "childList" && e.addedNodes.forEach((c) => {
        var a;
        if (c instanceof HTMLStyleElement && ((a = c.getAttribute("cssr-id")) != null && a.startsWith("vueuc"))) {
          const u = n.get(s);
          u && u.shadowRoots.forEach((l) => {
            d(s, l);
          });
        }
      });
  });
  t.observe(s, { childList: !0 });
  const o = {
    observer: t,
    shadowRoots: /* @__PURE__ */ new Set()
  };
  return n.set(s, o), o;
}, h = {
  mounted(s, t) {
    const o = t.value;
    if (!o) {
      console.error("vCopyVueucStylesToShadowDom 指令需要一个 ShadowRoot 作为参数。");
      return;
    }
    i(document.head).shadowRoots.add(o), d(document.head, o);
    const e = document.querySelector("qiankun-head");
    e && (i(e).shadowRoots.add(o), d(e, o));
  },
  beforeUnmount(s, t) {
    const o = t.value;
    if (o) {
      for (const [r, e] of n.entries())
        if (e.shadowRoots.has(o)) {
          e.shadowRoots.delete(o), e.shadowRoots.size === 0 && (e.observer.disconnect(), n.delete(r));
          break;
        }
    }
  }
};
export {
  h as vCopyVueucStylesToShadowDom
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/utils/vCopyVueucStylesToShadowDom.js
// module id = 55
// module chunks = 41